import { AbortableAPI, API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from '../../constants';
const { C300 } = GW_SERVICES_PREFIXES;

/* Создание задачи формирования отчёта
   После данного запроса начнётся длительное формирование отчёта */
export const CreateManagementAccountingReport = (
  params: IParams,
  signal?: AbortSignal
) =>
  AbortableAPI.post(`/${C300}/management_accounting/main_report/`, {
    body: params,
    signal,
  });

/* Формирование изменения тарифов */
export const CreateTariffChanges = (params: IParams) =>
  API.gatewayPost(
    `/${C300}/management_accounting/main_report/tariff_changes/`,
    params
  );

/* Создание задачи формирования отчёта по исполнителям */
export const CreateExecutorsReport = (params: IParams, signal?: AbortSignal) =>
  AbortableAPI.post(`/${C300}/management_accounting/executors_report/`, {
    body: params,
    signal,
  });

/* Добавление контрактов исполнителям */
export const CreateExecutorContract = (params: IParams) =>
  API.gatewayPost(`/${C300}/management_accounting/contracts/`, params);

/* Редактирование договора (контракта) */
export const EditExecutorsContract = (contractId: string, data: IParams) =>
  API.gatewayPatch(
    `/${C300}/management_accounting/contracts/`,
    contractId,
    data
  );

/* Добавление условий контракта */
export const CreateContractsAgreement = (params: IParams) =>
  API.gatewayPost(`/${C300}/management_accounting/agreements/`, params);

/* Получение сформированного отчёта по исполнителям */
export const GetExecutorsReportData = (id: string, signal?: AbortSignal) =>
  AbortableAPI.get(`/${C300}/management_accounting/executors_report/${id}/`, {
    signal,
  });

/* Получение сформированного отчёта */
export const GetManagementAccountingReportData = (
  id: string,
  params: IParams,
  signal?: AbortSignal
) =>
  AbortableAPI.get(`/${C300}/management_accounting/main_report/${id}/`, {
    params,
    signal,
  });

/* Получение кэшированного отчёта за прошлый год */
export const GetPreviousYearReportData = () =>
  API.get(`/${C300}/management_accounting/main_report/previous_year/`);

/* Получение информации о контракте */
export const GetExecutorContractData = (id: string) =>
  API.get(`/${C300}/management_accounting/contracts/`, id);

/* Получение сервисов для Строки начисления условий расчётов (с разделением на ресурсоснаьжение/жку) */
export const GetProviderAccrualServices = (params?: {
  start_period: string | null;
  end_period: string | null;
}) =>
  API.gatewayPost(`/${C300}/management_accounting/provider_services/`, params);

/* Получение домов отфильтрованные по выбранному сервису */
export const GetUnderServiceHouses = (params: IParams) =>
  API.get(`/${C300}/models/under_service_houses/`, undefined, params);

/* Изменение условий контракта */
export const UpdateContractsAgreement = (id: string, params: any) =>
  API.gatewayPatch(`/${C300}/management_accounting/agreements/`, id, params);

/* Удаление контрактов */
export const DeleteExecutorContract = (id: string) =>
  API.delete(`/${C300}/management_accounting/contracts/`, id);

/* Удаление условий контракта */
export const DeleteContractsAgreement = (id: string) =>
  API.delete(`/${C300}/management_accounting/agreements/`, id);
